module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-8.9d75ad8f.png";